import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import Controller from '@ember/controller';
import DS from 'ember-data';
import RouterService from '@ember/routing/router-service';
import { action } from '@ember/object';
import CampaignTemplatesService, { CAMPAIGN_TEMPLATES, CampaignTemplate } from 'cio/services/campaign-templates';
import AnalyticsService from 'cio/services/analytics';

export default class CampaignsWelcomeCreateCampaignController extends Controller {
  @service store!: DS.Store;
  @service router!: RouterService;
  @service campaignTemplates!: CampaignTemplatesService;
  @service analytics!: AnalyticsService;

  @tracked selectedTemplate?: CampaignTemplate;

  readonly templates = CAMPAIGN_TEMPLATES;

  @action
  async handleSelectTemplate(template: CampaignTemplate) {
    this.selectedTemplate = template;

    if (this.selectedTemplate?.templateId == null) {
      this.analytics.track('campaign', 'empty_state_create_from_scratch_selected');
      this.router.transitionTo('campaigns.new');
      return;
    }

    this.analytics.track('campaign', 'empty_state_template_selected', {
      title: this.selectedTemplate.title,
    });
    let campaignId = await this.campaignTemplates.createCampaignFromTemplate.perform(this.selectedTemplate.templateId);

    this.router.transitionTo('campaigns.campaign.setup.workflow.actions', campaignId);
  }
}
